import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Button, IconAi } from '@sparkol/videoscribe-react-ui';
import IconSearchEmpty from 'js/shared/icons/IconSearchEmpty';
import { AiPanelTab, ImageCategory, LeftHandPanel } from 'js/types';
import { showLeftHandPanel } from 'js/actionCreators/uiActions';
import { ChangeStepTrigger } from 'js/actionCreators/aiFeaturesActions';

import './SearchResultEmptyState.css';

import CategoriesList from '../../../CategoriesList';

type SearchResultEmptyStateProps = {
  tab: string;
  alternativeTab?: string;
  onCategoryClick: (category: ImageCategory) => void;
};

const SearchResultEmptyState: React.FC<SearchResultEmptyStateProps> = ({ tab, alternativeTab, onCategoryClick }) => {
  const dispatch = useDispatch();
  const message = useMemo(
    () => `Sorry, there are no images within '${tab}' that match your search term(s). You can try either:`,
    [tab]
  );
  const options = useMemo(
    () => [
      ...(alternativeTab ? [`Looking in the '${alternativeTab}' section above`] : []),
      'Editing your search term(s)',
      'Browsing the categories below',
      'Generating an image with AI'
    ],
    [alternativeTab]
  );
  const handleOpenImageAiClick = () =>
    dispatch(
      showLeftHandPanel(LeftHandPanel.AI_GENERATION, AiPanelTab.IMAGE_GENERATION, ChangeStepTrigger.IMAGE_LIBRARY)
    );

  return (
    <div className="SearchResultEmptyState">
      <div className="SearchResultEmptyState__message-container">
        <div className="SearchResultEmptyState__message-container--left">
          <IconSearchEmpty />
        </div>
        <div className="SearchResultEmptyState__message-container--right">
          <p className="SearchResultEmptyState__message">{message}</p>
          <ul className="SearchResultEmptyState__option-list">
            {options.map((option, index) => (
              <li key={index} className="SearchResultEmptyState__option">
                {option}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="SearchResultEmptyState__ai-button-container">
        <div>
          <Button fullWidth variant="ai" icon={<IconAi />} onClick={handleOpenImageAiClick}>
            Go to generate AI image
          </Button>
        </div>
      </div>
      <CategoriesList onCategoryClick={onCategoryClick} />
    </div>
  );
};

export default SearchResultEmptyState;
